module.exports = __webpack_public_path__ + "static/floor-68663cb1172cfc12f60d8113b7c9a068.png";